import { render, staticRenderFns } from "./Orcamento.vue?vue&type=template&id=09d9b84e&scoped=true&"
import script from "./Orcamento.vue?vue&type=script&lang=js&"
export * from "./Orcamento.vue?vue&type=script&lang=js&"
import style0 from "./Orcamento.vue?vue&type=style&index=0&id=09d9b84e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d9b84e",
  null
  
)

export default component.exports